import styled from 'styled-components'

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 64px 0;
`

export const Container = styled.div` 
width: 580px;
height: fit-content;
border: 1px solid #e6e9ec;
background: #ffffff;
padding: 24px 36px;
box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
border-radius: 3px;
`

export const Info = styled.div` 
    display:flex;
    justify-content: space-between;
    margin-top: 14px;
    
`

export const Error = styled.div` 
color: red;
`